import React from "react";
import { iconProps } from "../../../Helper";

export const HumanizeIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        className={className}
        d="M3.16553 9.46965C3.53821 8.97052 4.02231 8.56533 4.57926 8.28636C5.13621 8.00739 5.75062 7.86235 6.37353 7.86279C7.30838 7.86279 8.16781 8.18279 8.84896 8.71994"
        stroke="white"
        stroke-linecap="round"
      />
      <path
        className={className}
        d="M5.80106 12.1473H1.80106C1.49796 12.1473 1.20727 12.0269 0.992938 11.8126C0.778611 11.5983 0.658203 11.3076 0.658203 11.0045V1.86161C0.658203 1.5585 0.778611 1.26781 0.992938 1.05349C1.20727 0.839158 1.49796 0.71875 1.80106 0.71875H10.9439C11.247 0.71875 11.5377 0.839158 11.752 1.05349C11.9664 1.26781 12.0868 1.5585 12.0868 1.86161V5.29018"
        stroke="white"
        stroke-linecap="round"
      />
      <path
        className={className}
        d="M6.37249 6.14732C6.59761 6.14732 6.82053 6.10298 7.02852 6.01683C7.2365 5.93068 7.42549 5.8044 7.58467 5.64522C7.74386 5.48603 7.87013 5.29705 7.95628 5.08906C8.04243 4.88108 8.08677 4.65816 8.08677 4.43304C8.08677 4.20791 8.04243 3.98499 7.95628 3.77701C7.87013 3.56902 7.74386 3.38004 7.58467 3.22085C7.42549 3.06167 7.2365 2.93539 7.02852 2.84924C6.82053 2.76309 6.59761 2.71875 6.37249 2.71875C5.91783 2.71875 5.4818 2.89936 5.16031 3.22085C4.83881 3.54234 4.6582 3.97838 4.6582 4.43304C4.6582 4.88769 4.83881 5.32373 5.16031 5.64522C5.4818 5.96671 5.91783 6.14732 6.37249 6.14732ZM8.38849 12.0719C7.98735 12.0022 7.98735 11.4262 8.38849 11.3565C9.09851 11.2323 9.75557 10.8997 10.2761 10.4012C10.7967 9.90259 11.1572 9.26048 11.3119 8.55646L11.3359 8.44561C11.4228 8.04904 11.9873 8.04675 12.0776 8.44218L12.1073 8.57132C12.267 9.27261 12.6305 9.91101 13.1521 10.4062C13.6737 10.9014 14.3301 11.2312 15.0388 11.3542C15.4422 11.425 15.4422 12.0033 15.0388 12.0742C14.3301 12.1972 13.6737 12.527 13.1521 13.0222C12.6305 13.5173 12.267 14.1557 12.1073 14.857L12.0776 14.9862C11.9873 15.3816 11.4228 15.3793 11.3359 14.9828L11.3119 14.8719C11.1572 14.1679 10.7967 13.5258 10.2761 13.0272C9.75557 12.5286 9.09851 12.1961 8.38849 12.0719Z"
        stroke="white"
        stroke-linecap="round"
      />
    </svg>
  );
};
